(() => {
  const buttons = [...document.querySelectorAll('[data-lumi-home-quick-add]')];
  if (!buttons.length) return;

  const addUrl = window.routes?.cart_add_url || '/cart/add.js';

  buttons.forEach((button) => {
    button.addEventListener('click', async () => {
      if (button.disabled || button.dataset.loading === 'true') return;
      const variantId = Number(button.dataset.variantId || 0);
      if (!variantId) return;

      const original = button.textContent;
      button.dataset.loading = 'true';
      button.disabled = true;
      button.textContent = 'Adding…';

      try {
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || 'Unable to add this item.');
        }

        if (typeof window.LumiSyncGift === 'function') await window.LumiSyncGift();
        document.dispatchEvent(new CustomEvent('lumi:cart-updated'));
        button.textContent = 'Added ✓';
        window.setTimeout(() => {
          button.textContent = original;
          button.disabled = false;
          button.dataset.loading = 'false';
        }, 1300);
      } catch (error) {
        button.textContent = 'Try again';
        button.disabled = false;
        button.dataset.loading = 'false';
        window.setTimeout(() => { button.textContent = original; }, 1600);
      }
    });
  });
})();
